export default {
  // Navbar
  'nav.home': '首页',
  'nav.packaging': '产品',
  'nav.customization': '定制',
  'nav.aiPreview': 'AI 预览',
  'nav.quotation': '报价',
  'nav.howItWorks': '使用流程',
  'nav.supplierNetwork': '制造联盟',
  'nav.qualityControl': '品质管理',
  'nav.aboutUs': '关于我们',
  'nav.contact': '联系我们',
  'nav.signIn': '登录',
  'nav.getQuote': '获取报价',
  'nav.uploadImage': '上传图片',
  'nav.language': '语言',
  'nav.currency': '货币',

  // Hero
  'hero.badge': '全球 B2B 化妆品包装门户',
  'hero.title': '从已验证的大型供应商处寻找并定制化妆品包装',
  'hero.subtitle': '一站式搜索数千种化妆品容器、比较选项、预览后加工，并获取可靠的 B2B 报价。',
  'hero.quickLinks': '热门',
  'hero.loading': '加载中...',
  'hero.cta.browse': '浏览全部包装',
  'hero.cta.upload': '上传参考图片',
  'hero.cta.quote': '获取报价',
  'hero.cta.searchByPhoto': '按产品照片搜索',
  'hero.searchByPhoto.title': '图片搜索',
  'hero.searchByPhoto.dragDrop': '将图片拖放到此处，或点击上传',
  'hero.searchByPhoto.maxSize': '支持所有图片格式，最大 10MB',
  'hero.searchByPhoto.or': '或',
  'hero.searchByPhoto.upload': '上传图片',
  'hero.searchByPhoto.takePhoto': '拍照',

  // Announcement
  'announcement.label': '公告',
  'announcement.viewAll': '查看全部',

  // Value Cards
  'value.sectionLabel': '为什么选择 GBCOSPACK',
  'value.sectionTitle': '我们的优势',
  'value.sectionSubtitle': '专业可靠、值得信赖的合作伙伴',
  'value.suppliers.title': '1000+ 供应商网络',
  'value.suppliers.desc': '通过标准化的产品数据和透明的价格，触达中国各地经过验证的包装制造商。',
  'value.moq.title': '低起订量方案',
  'value.moq.desc': '寻找提供小批量最低起订量的供应商，非常适合初创企业、样品和市场测试。',
  'value.ai.title': 'AI 后加工预览',
  'value.ai.desc': '在下单样品前，预览高光盖、磨砂瓶身、金属质感与哑光纹理的实际效果。',
  'value.transparent.title': '透明报价与品质管理',
  'value.transparent.desc': '获取包含后加工成本的详细报价，并在每个生产阶段跟踪品质管理。',

  // Categories
  'categories.subtitle': '我们的产品',
  'categories.title': '按分类浏览',
  'categories.airless': '真空瓶',
  'categories.pump': '泵头瓶',
  'categories.dropper': '滴管瓶',
  'categories.cream': '膏霜罐',
  'categories.tubes': '软管',
  'categories.cushion': '气垫 / 粉饼盒',
  'categories.lip': '唇部 / 彩妆包装',
  'categories.refill': '替换装容器',
  'categories.eco': '环保包装',
  'categories.viewAll': '查看全部产品',
  'categories.browse': '浏览',
  'categories.empty': '暂无已注册的产品。',

  // AI Preview
  'aiPreview.label': 'AI 技术',
  'aiPreview.title': '打样前预览 AI 后加工效果',
  'aiPreview.subtitle': '上传设计，几秒钟内查看不同后加工如何改变您的包装。',
  'aiPreview.glossy': '高光盖',
  'aiPreview.glossy.desc': '高亮反光效果，彰显高级质感',
  'aiPreview.frosted': '磨砂瓶身',
  'aiPreview.frosted.desc': '优雅的半透明哑光质感',
  'aiPreview.metallic': '金属质感',
  'aiPreview.metallic.desc': '奢华金属般的表面处理',
  'aiPreview.matte': '柔软触感哑光',
  'aiPreview.matte.desc': '丝绒般的触感涂层体验',
  'aiPreview.color': '颜色变换',
  'aiPreview.color.desc': '定制潘通色匹配与渐变',
  'aiPreview.uv': 'UV 涂层',
  'aiPreview.uv.desc': '高光润泽的表面保护层',
  'aiPreview.embossed': '浮雕纹理',
  'aiPreview.embossed.desc': '3D 立体图案与触感凸起表面',
  'aiPreview.pearl': '珍珠光泽',
  'aiPreview.pearl.desc': '虹彩般绚丽的彩虹反光效果',
  'aiPreview.tryNow': '探索定制后加工',

  // CTA
  'cta.label': '企业解决方案',
  'cta.title': '大批量采购的专属支持',
  'cta.desc': '我们的客户经理将协助您完成定制规格、大批量谈判以及端到端物流。从初步询价到最终交付，我们全程管理您的采购流程。',
  'cta.button': '联系销售',

  // Quotation Process
  'quotation.title': '如何下单',
  'quotation.subtitle': '通过六个简单步骤，从发现到交付',
  'quotation.step1': '选择产品',
  'quotation.step1.desc': '浏览数千种容器，找到完美之选',
  'quotation.step2': '选择后加工（可选）',
  'quotation.step2.desc': '挑选盖子样式、颜色、纹理与装饰',
  'quotation.step3': '请求报价',
  'quotation.step3.desc': '获取包含起订量与交期的透明价格',
  'quotation.step4': '打样（可选）',
  'quotation.step4.desc': '在大规模生产前审核实物样品',
  'quotation.step5': '确认下单',
  'quotation.step5.desc': '通过安全支付与合同确认订单',
  'quotation.step6': '品质管理及交付',
  'quotation.step6.desc': '品质检验与全球配送直达您的门前',

  // Trust
  'trust.label': '品牌信赖我们的原因',
  'trust.title': '我们弥合全球化妆品品牌与经验证的中国包装供应商之间的鸿沟，让采购透明、高效且可靠。',
  'trust.suppliers': '经验证的供应商',
  'trust.suppliers.desc': '每家工厂在加入我们的网络前都经过审核与验证。',
  'trust.data': '标准化数据',
  'trust.data.desc': '所有产品均采用统一规格表，便于比较。',
  'trust.price': '透明定价',
  'trust.price.desc': '无隐藏费用，费用明细提前一目了然。',
  'trust.qc': '品质管理清单',
  'trust.qc.desc': '工厂端与发货前的多阶段品质管理。',
  'trust.delivery': '全球配送',
  'trust.delivery.desc': '面向 50 多个国家的门到门物流支持。',
  'trust.stat.suppliers': '1,000+',
  'trust.stat.suppliers.label': '经验证的供应商',
  'trust.stat.products': '50,000+',
  'trust.stat.products.label': '产品 SKU',
  'trust.stat.countries': '50+',
  'trust.stat.countries.label': '服务国家',
  'trust.stat.satisfaction': '98%',
  'trust.stat.satisfaction.label': '客户满意度',

  // Testimonial
  'testimonial.title': '客户评价',
  'testimonial.rating': '4.9 / 5.0',
  'testimonial.review1': '"PackVerse 帮助我们找到了护肤系列所需的精确真空瓶。AI 预览功能为我们省去了与供应商反复沟通的数周时间。我们在 10 天内收到样品，并在 4 周内完成了第一笔订单。"',
  'testimonial.author1': 'Sarah Kim',
  'testimonial.role1': '创始人，Lumiere Beauty Co.',
  'testimonial.review2': '"作为一家服务东南亚品牌的 OEM 公司，我们需要起订量低且可靠的包装来源。这个平台正是行业所需。"',
  'testimonial.author2': 'Mark Tan',
  'testimonial.role2': '采购总监，ASEAN Cosmo OEM',

  // Search
  'search.quickTitle': '快速搜索',
  'search.placeholder': '按产品名称、材质或关键词搜索...',
  'search.visual': '上传图片搜索',
  'search.button': '搜索',
  'search.dropHere': '将图片拖放到此处进行搜索',
  'search.searchingByImage': '正在按图片搜索...',
  'search.imageSearchResult': '找到 {{count}} 个相似产品',
  'search.imageSearchFailed': '图片搜索失败，请重试。',
  'search.imageSearchUnavailable': '图片搜索服务当前不可用。',
  'search.apiRouteNotFound': '未找到 API 路由。请检查 Cursor API 路由 /api/customer/image-search 及代理设置。',
  'search.browseInstead': '改为浏览我们的产品目录。',
  'search.noSimilarProducts': '未找到相似产品，请尝试其他图片。',
  'search.searchByImageTitle': '按图片搜索',
  'search.searchByImageDesc': '上传参考图片以查找相似的包装。',
  'search.imageSearchSubmitted': '图片已上传，正在跳转到结果...',
  'search.viewResults': '查看结果',
  'search.dismiss': '关闭',
  'search.upload': '上传',
  'search.camera': '拍照',
  'search.cancel': '取消',
  'search.findSimilar': '查找相似',
  'search.retake': '重新拍摄',
  'search.reupload': '重新上传',
  'search.browseAll': '浏览全部产品',
  'search.bannerTitle': '正在寻找适合您品牌的化妆品包装？',
  'search.bannerDesc': '探索 20,000 多种不同材质与设计的化妆品包装，并通过 GBCOSPACK 的一站式 B2B 采购服务获取定制后加工报价。',

  // Newsletter
  'newsletter.label': '保持关注',
  'newsletter.title': '订阅我们的新闻通讯',
  'newsletter.subtitle': '将最新的包装趋势、新供应商资讯与行业洞察发送到您的邮箱。',
  'newsletter.placeholder': '输入您的邮箱地址',
  'newsletter.button': '订阅',
  'newsletter.success': '感谢您的订阅！',
  'newsletter.error': '请输入有效的邮箱地址。',

  // Footer
  'footer.company': '公司',
  'footer.about': '关于我们',
  'footer.careers': '加入我们',
  'footer.press': '新闻资讯',
  'footer.blog': '博客',
  'footer.packaging': '包装',
  'footer.browse': '浏览全部',
  'footer.categories': '分类',
  'footer.others': '其他',
  'footer.customization': '定制',
  'footer.finishing': '后加工选项',
  'footer.aiPreview': 'AI 预览',
  'footer.design': '设计支持',
  'footer.quote': '报价',
  'footer.request': '请求报价',
  'footer.moq': '起订量指南',
  'footer.pricing': '价格',
  'footer.support': '支持',
  'footer.help': '帮助中心',
  'footer.shipping': '配送信息',
  'footer.returns': '退换货',
  'footer.terms': '服务条款',
  'footer.privacy': '隐私政策',
  'footer.contact': '联系我们',
  'footer.rights': '版权所有。',
  'footer.brand': 'PackVerse',
  'footer.tagline': '全球化妆品包装采购门户',
};